var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.productToUnassign
        ? _c(
            "b-modal",
            {
              attrs: {
                title: "Product unassign",
                "modal-class": "vue-need-bootstrap",
                lazy: "",
                centered: "",
                "no-close-on-backdrop": "",
              },
              on: {
                ok: function ($event) {
                  return _vm.unassignProduct(_vm.productToUnassign)
                },
              },
              model: {
                value: _vm.showUnassignConfirmModal,
                callback: function ($$v) {
                  _vm.showUnassignConfirmModal = $$v
                },
                expression: "showUnassignConfirmModal",
              },
            },
            [
              _c("div", [
                _vm._v("\n            Do you want to unassign the product "),
                _c("b", [
                  _vm._v('"' + _vm._s(_vm.productToUnassign.title) + '"'),
                ]),
                _vm._v("?\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3" }, [
                _vm._v("If you click "),
                _c("b", [_vm._v("OK")]),
                _vm._v(
                  " there's no oopsies, no refunds, no come backs! I warned you!"
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.step === "selectProduct"
        ? _c(
            "div",
            { staticClass: "col" },
            [
              !_vm.products || !_vm.products.length
                ? _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c("b-spinner", {
                        staticClass: "my-2",
                        attrs: { variant: "primary" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.products && _vm.products.length
                ? _c("product-selector", {
                    attrs: { products: _vm.products },
                    on: {
                      "product-select": _vm.onProductSelected,
                      "product-unassign": _vm.onProductUnassignClick,
                    },
                    model: {
                      value: _vm.selectedProducts,
                      callback: function ($$v) {
                        _vm.selectedProducts = $$v
                      },
                      expression: "selectedProducts",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm.step === "selectPrintProviders"
        ? _c("div", { staticClass: "col" }, [
            !_vm.printProviders
              ? _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("b-spinner", {
                      staticClass: "my-2",
                      attrs: { variant: "primary" },
                    }),
                  ],
                  1
                )
              : _c("div", [
                  _vm.printProviders.length
                    ? _c(
                        "div",
                        [
                          _c("multi-select-table", {
                            attrs: {
                              items: _vm.printProviders,
                              fields: _vm.printProvidersTableFields,
                              "show-done-button":
                                _vm.selectedPrintProviders.length > 0,
                              "max-selections": 1,
                              title: "Select print providers",
                            },
                            on: {
                              "selection-finished":
                                _vm.onPrintProvidersSelected,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "cell(name)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "align-items-center d-flex h-100",
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(_vm._s(data.item.title)),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3826210341
                            ),
                            model: {
                              value: _vm.selectedPrintProviders,
                              callback: function ($$v) {
                                _vm.selectedPrintProviders = $$v
                              },
                              expression: "selectedPrintProviders",
                            },
                          }),
                        ],
                        1
                      )
                    : _c("div", [_vm._v("No print providers available")]),
                ]),
          ])
        : _vm.step === "selectPlaceholders" && _vm.selectedProduct
        ? _c(
            "div",
            { staticClass: "col" },
            [
              _c("variants-configurator", {
                attrs: {
                  "pod-service": "printify",
                  "selected-print-providers": _vm.selectedPrintProviders,
                  "selected-product-id": _vm.selectedProduct.id,
                  store: _vm.store,
                  configurations:
                    _vm.templateProductConfiguration.configurations,
                },
                on: {
                  "variants-selected": _vm.onPlaceholdersSelectionFinished,
                },
              }),
            ],
            1
          )
        : _vm.step === "finalRevision" && _vm.selectedProduct
        ? _c(
            "div",
            { staticClass: "col" },
            [
              _c("revision-step", {
                attrs: {
                  "pod-service": "printify",
                  "product-title": _vm.selectedProduct.title,
                  "provider-variants": _vm.selectedProviderVariants,
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary float-right",
                  on: {
                    click: function ($event) {
                      return _vm.onSave()
                    },
                  },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }